export enum HttpStatusCodes {
  Forbidden = 403,
  BadRequest = 400,
  NotFound = 404,
  Unauthorized = 401,
  InternalServerError = 500
}
